import SetupCC from "./components/SetupCC";

export default SetupCC;
